const processInclude = require('base/util');
const { onDOMContentLoaded } = require('./common/utils/domEvents');

onDOMContentLoaded(() => {
  processInclude(require('./repentance/repentance'));
});
